"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _redux = require("redux");
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _Spinner = _interopRequireDefault(require("../common/Spinner/Spinner"));
var _resize = _interopRequireDefault(require("../../hocs/resize"));
var _decimalPlacesHelper = require("../../helpers/decimalPlaces/decimalPlacesHelper");
require("@alphapoint/apex-chart-react/lib/chart-style.css");
require("../../styles/components/TradeComponent.css");
require("./DepthChart.css");
var _withCssVars = require("../Theme/withCssVars");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var tradeComponentClasses = (0, _cssClassesHelper.getBEMClasses)('trade-component');
var depthChartComponentClasses = (0, _cssClassesHelper.getBEMClasses)('depth-chart');
var mousePos = {
  x: 0,
  y: 0
};
var mouseOver = false;
var defaultDepthChartZoom = 5;
var DEFAULT_MAX_BID_PRICE = 0;
var DEFAULT_MIN_ASK_PRICE = Number.MAX_SAFE_INTEGER;
var MAX_ZOOM_VALUE = 1000;
var MIN_ZOOM_VALUE = 0.0001;
var DepthChartComponent = /*#__PURE__*/function (_React$Component) {
  function DepthChartComponent(props) {
    var _this;
    _classCallCheck(this, DepthChartComponent);
    _this = _callSuper(this, DepthChartComponent, [props]);
    _defineProperty(_this, "setListeners", function () {
      var chartDom = document.getElementById('depthchart');
      chartDom.addEventListener('mouseover', function () {
        mouseOver = true;
      });
      chartDom.addEventListener('mouseout', function () {
        mouseOver = false;
        _this.drawChart();
      });
      chartDom.addEventListener('mousemove', function (evt) {
        var rect = chartDom.getBoundingClientRect();
        mousePos = {
          x: evt.clientX - rect.left,
          y: evt.clientY - rect.top
        };
        _this.drawChart();
      });
      chartDom.addEventListener('click', function () {
        if (_this.mouseHoverBuy) {
          _this.props.buyPriceClicked(_this.closestMousePositionInfo.price);
        } else {
          _this.props.sellPriceClicked(_this.closestMousePositionInfo.price);
        }
      });
    });
    _defineProperty(_this, "getSellTooltipRotation", function (tooltipSize, offsetCentralChartLine, priceAxisHeight) {
      var marginTop = _this.closestMousePositionInfo.y - tooltipSize.height;
      var marginLeft = _this.closestMousePositionInfo.x - tooltipSize.width;
      var marginBottom = _this.closestMousePositionInfo.y + tooltipSize.height;
      var centralChartLimit = _this.chartWidth / 2 + offsetCentralChartLine;
      var bottomChartLimit = _this.chartHeight - priceAxisHeight;
      var rightBottomRotation = marginLeft <= centralChartLimit && marginTop <= 0;
      var rightTopRotation = marginLeft <= centralChartLimit && marginBottom >= bottomChartLimit;
      var leftBottomRotation = marginLeft >= centralChartLimit && marginTop <= 0;
      if (rightBottomRotation) {
        return {
          x: 1,
          y: -1
        };
      } else if (rightTopRotation) {
        return {
          x: 1,
          y: 1
        };
      } else if (leftBottomRotation) {
        return {
          x: -1,
          y: -1
        };
      } else {
        return {
          x: -1,
          y: 1
        };
      }
    });
    _defineProperty(_this, "getBuyTooltipRotation", function (tooltipSize, offsetCentralChartLine, priceAxisHeight) {
      var marginTop = _this.closestMousePositionInfo.y - tooltipSize.height;
      var marginRight = _this.closestMousePositionInfo.x + tooltipSize.width;
      var marginBottom = _this.closestMousePositionInfo.y + tooltipSize.height;
      var centralChartLimit = _this.chartWidth / 2 - offsetCentralChartLine;
      var bottomChartLimit = _this.chartHeight - priceAxisHeight;
      var leftBottomRotation = marginRight >= centralChartLimit && marginTop <= 0;
      var leftTopRotation = marginRight >= centralChartLimit && marginBottom >= bottomChartLimit;
      var rightBottomRotation = marginRight <= centralChartLimit && marginTop <= 0;
      if (leftBottomRotation) {
        return {
          x: -1,
          y: -1
        };
      } else if (leftTopRotation) {
        return {
          x: -1,
          y: 1
        };
      } else if (rightBottomRotation) {
        return {
          x: 1,
          y: -1
        };
      } else {
        return {
          x: 1,
          y: 1
        };
      }
    });
    _defineProperty(_this, "renderTooltip", function (depthChartTextFont, depthChartTextColor, lastTradeUpColorTransparent, lastTradeDownColorTransparent) {
      var tooltipSize = {
        width: 100,
        height: 60,
        paddingLeft: 20,
        paddingTop: 10
      };
      var offsetCentralChartLine = 60;
      var priceAxisHeight = 10;
      var sellTooltipRotation = _this.getSellTooltipRotation(tooltipSize, offsetCentralChartLine, priceAxisHeight);
      var buyTooltipRotation = _this.getBuyTooltipRotation(tooltipSize, offsetCentralChartLine, priceAxisHeight);
      var getFieldPositionX = function getFieldPositionX() {
        var padding = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var x = _this.closestMousePositionInfo.x;
        var tooltipRotation = _this.mouseHoverBuy ? buyTooltipRotation : sellTooltipRotation;
        var rightBottomRotation = tooltipRotation.x === 1 && tooltipRotation.y === -1;
        var rightTopRotation = tooltipRotation.x === 1 && tooltipRotation.y === 1;
        if (rightBottomRotation || rightTopRotation) {
          return x + tooltipSize.paddingLeft + padding;
        } else {
          return x - tooltipSize.width + tooltipSize.paddingLeft + padding;
        }
      };
      var getFieldPositionY = function getFieldPositionY() {
        var padding = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var y = _this.closestMousePositionInfo.y;
        var tooltipRotation = _this.mouseHoverBuy ? buyTooltipRotation : sellTooltipRotation;
        var rightBottomRotation = tooltipRotation.x === 1 && tooltipRotation.y === -1;
        var leftBottomRotation = tooltipRotation.x === -1 && tooltipRotation.y === -1;
        if (rightBottomRotation || leftBottomRotation) {
          return y + tooltipSize.paddingTop + padding;
        } else {
          return y - tooltipSize.height + tooltipSize.paddingTop + padding;
        }
      };
      if (mouseOver && (_this.mouseHoverBuy || _this.mouseHoverSell)) {
        _this.ctx2.beginPath();
        _this.ctx2.arc(_this.closestMousePositionInfo.x, _this.closestMousePositionInfo.y, 3, 0, 2 * Math.PI, false);
        _this.ctx2.fillStyle = 'rgba(205,205,205, 0.3)';
        _this.ctx2.fill();
        _this.ctx2.lineWidth = 1;
        _this.ctx2.strokeStyle = 'rgba(205,205,205, 0.3)';
        _this.ctx2.stroke();
        if (_this.mouseHoverBuy) {
          _this.ctx2.font = depthChartTextFont;
          _this.ctx2.fillStyle = depthChartTextColor;
          _this.ctx2.fillText(_this.closestMousePositionInfo.price.toFixed((0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(_this.props.selectedInstrument.PriceIncrement)), getFieldPositionX(), getFieldPositionY(10));
          _this.ctx2.fillText('Buy', getFieldPositionX(), getFieldPositionY(25));
          _this.ctx2.fillText(_this.closestMousePositionInfo.volume.toFixed((0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(_this.props.selectedInstrument.PriceIncrement)), getFieldPositionX(30), getFieldPositionY(25));
          _this.ctx2.fillText('Cost', getFieldPositionX(), getFieldPositionY(40));
          _this.ctx2.fillText((_this.closestMousePositionInfo.volume * _this.closestMousePositionInfo.price).toFixed((0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(_this.props.selectedInstrument.PriceIncrement)), getFieldPositionX(30), getFieldPositionY(40));
          _this.ctx2.fillStyle = lastTradeUpColorTransparent;
          _this.ctx2.fillRect(_this.closestMousePositionInfo.x, _this.closestMousePositionInfo.y - tooltipSize.height * buyTooltipRotation.y, tooltipSize.width * buyTooltipRotation.x, tooltipSize.height * buyTooltipRotation.y);
        }
        if (_this.mouseHoverSell) {
          _this.ctx2.font = depthChartTextFont;
          _this.ctx2.fillStyle = depthChartTextColor;
          _this.ctx2.fillText(_this.closestMousePositionInfo.price.toFixed((0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(_this.props.selectedInstrument.PriceIncrement)), getFieldPositionX(), getFieldPositionY(10));
          _this.ctx2.fillText('Buy', getFieldPositionX(), getFieldPositionY(25));
          _this.ctx2.fillText(_this.closestMousePositionInfo.volume.toFixed((0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(_this.props.selectedInstrument.PriceIncrement)), getFieldPositionX(30), getFieldPositionY(25));
          _this.ctx2.fillText('Cost', getFieldPositionX(), getFieldPositionY(40));
          _this.ctx2.fillText((_this.closestMousePositionInfo.volume * _this.closestMousePositionInfo.price).toFixed((0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(_this.props.selectedInstrument.PriceIncrement)), getFieldPositionX(30), getFieldPositionY(40));
          _this.ctx2.fillStyle = lastTradeDownColorTransparent;
          _this.ctx2.fillRect(_this.closestMousePositionInfo.x, _this.closestMousePositionInfo.y - tooltipSize.height * sellTooltipRotation.y, tooltipSize.width * sellTooltipRotation.x, tooltipSize.height * sellTooltipRotation.y);
        }
      }
    });
    _defineProperty(_this, "zoomDepthChartPlus", function () {
      var newDepthChartZoom = _this.state.depthchartzoom / 1.25;
      if (newDepthChartZoom < MIN_ZOOM_VALUE) {
        _this.setState({
          depthchartzoom: MIN_ZOOM_VALUE
        });
      } else {
        _this.setState({
          depthchartzoom: newDepthChartZoom
        });
      }
      _this.drawChart();
    });
    _defineProperty(_this, "zoomDepthChartMinus", function () {
      var newDepthChartZoom = _this.state.depthchartzoom * 1.25;
      if (newDepthChartZoom > MAX_ZOOM_VALUE) {
        _this.setState({
          depthchartzoom: MAX_ZOOM_VALUE
        });
      } else {
        _this.setState({
          depthchartzoom: newDepthChartZoom
        });
      }
      _this.drawChart();
    });
    _this.state = {
      depthchartzoom: MAX_ZOOM_VALUE - _this.props.DepthChart.depthchartzoom || defaultDepthChartZoom
    };
    return _this;
  }
  _inherits(DepthChartComponent, _React$Component);
  return _createClass(DepthChartComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setListeners();
      this.drawChart();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.selectedInstrument.InstrumentId !== this.props.selectedInstrument.InstrumentId) {
        this.setState({
          depthchartzoom: MAX_ZOOM_VALUE - (this.props.DepthChart.depthchartzoom || defaultDepthChartZoom)
        });
      }
      this.drawChart();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {}
  }, {
    key: "drawChart",
    value: function drawChart() {
      var _this$props = this.props,
        DepthChart = _this$props.DepthChart,
        smallScreen = _this$props.smallScreen,
        level2 = _this$props.level2,
        getCssVar = _this$props.getCssVar;
      var depthChartHeight = DepthChart.depthChartHeight + 50 || 300;
      var depthChartTextColor = DepthChart.depthChartTextColor || 'rgb(200,200,200)'; // Grey
      var depthChartTextFont = DepthChart.depthChartTextFont || '12px';
      var depthChartXAxisTextPadding = DepthChart.depthChartXAxisTextPadding || 60;
      var depthChartYAxisTextPadding = DepthChart.depthChartYAxisTextPadding || 20;
      var depthChartBottomPadding = DepthChart.depthChartBottomPadding || 20;
      var depthChartXAxisStepCnt = DepthChart.depthChartXAxisStepCnt || 9;
      var depthChartXAxisStepColor = getCssVar('chart__x-axis-step-color');
      var lastTradeDownColor = getCssVar('chart__bearish-color');
      var lastTradeDownColorTransparent = getCssVar('chart__bearish-color_transparent');
      var lastTradeUpColor = getCssVar('chart__bullish-color');
      var lastTradeUpColorTransparent = getCssVar('chart__bullish-color_transparent');
      var buyBook = level2.buy;
      var sellBook = level2.sell;
      var c2 = document.getElementById('depthchart');
      var ch = document.getElementById('depthChartHolder');
      c2.width = ch.clientWidth;
      c2.height = smallScreen ? ch.clientHeight : depthChartHeight;
      this.chartHeight = c2.height;
      this.chartWidth = c2.width;
      var maxBidPrice = DEFAULT_MAX_BID_PRICE;
      var minAskPrice = DEFAULT_MIN_ASK_PRICE;
      var sortedSellBook = sellBook.map(function (order) {
        return order.Price;
      });
      sortedSellBook.forEach(function (price) {
        if (price < minAskPrice) minAskPrice = price;
      });
      var sortedBuyBook = buyBook.map(function (order) {
        return order.Price;
      });
      sortedBuyBook.forEach(function (price) {
        if (price > maxBidPrice) maxBidPrice = price;
      });
      var center = (minAskPrice + maxBidPrice) / 2;
      this.relativeDepthChartZoom = Math.abs((minAskPrice - maxBidPrice) * this.state.depthchartzoom);
      var isPricesDefault = maxBidPrice === DEFAULT_MAX_BID_PRICE && minAskPrice === DEFAULT_MIN_ASK_PRICE;
      if (!isPricesDefault) {
        var midMarketPrice = document.getElementById('midMarketPrice');
        midMarketPrice.innerHTML = center.toFixed((0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(this.props.selectedInstrument.PriceIncrement));
      }
      var maxAskDisplay = center + this.relativeDepthChartZoom;
      var minBidDisplay = center - this.relativeDepthChartZoom;
      var visibleAskDepth = 0;
      var sellLevels = 0;
      for (var i = sortedSellBook.length - 1; i >= 0; --i) {
        if (sellBook[i].Price > maxAskDisplay) break;
        visibleAskDepth += sellBook[i].Quantity;
        ++sellLevels;
      }
      var visibleBidDepth = 0;
      var buyLevels = 0;
      for (var _i = 0; _i < sortedBuyBook.length; _i++) {
        if (buyBook[_i].Price < minBidDisplay) break;
        visibleBidDepth += buyBook[_i].Quantity;
        ++buyLevels;
      }
      var topvisibleDepth = visibleAskDepth;
      if (visibleBidDepth > visibleAskDepth) topvisibleDepth = visibleBidDepth;
      var multX = this.chartWidth / (this.relativeDepthChartZoom * 2); // pixels per unit of price
      var multY = (this.chartHeight - depthChartBottomPadding) / topvisibleDepth; // pixels per unit of depth

      this.ctx2 = c2.getContext('2d');
      this.ctx2.clearRect(0, 0, this.chartWidth, this.chartHeight);
      var lastY = this.chartHeight - depthChartBottomPadding;
      var lastX = this.chartWidth / 2;
      this.ctx2.beginPath();
      this.ctx2.moveTo(lastX, 50);
      this.ctx2.save();
      this.ctx2.lineWidth = 1;
      this.ctx2.lineTo(lastX, this.chartHeight - depthChartBottomPadding);
      this.ctx2.strokeStyle = depthChartTextColor;
      this.ctx2.stroke();
      this.mouseHoverBuy = false;
      this.mouseHoverSell = false;
      if (mousePos.x < lastX) {
        this.mouseHoverBuy = true;
      } else if (mousePos.x > lastX) {
        this.mouseHoverSell = true;
      }
      var lastTextEntry = lastX;
      lastX = this.chartWidth / 2 - (center - parseFloat(sortedBuyBook[0])) * multX;
      var lastXDrawn = 0;
      var lastYDrawn = 0;
      var lastTextEntryY = lastY;
      var lastTextEntryX = lastX;
      var depthShown = 0;
      this.closestMousePositionInfo = {
        price: 0,
        volume: 0,
        x: 0,
        y: 0,
        xdiff: 999999
      };
      this.closestMousePositionInfo.mouseX = mousePos.x;
      for (var _i2 = 0; _i2 < depthChartXAxisStepCnt; _i2++) {
        var xAxisText = (minBidDisplay + this.relativeDepthChartZoom * 2 / (depthChartXAxisStepCnt - 1) * _i2).toFixed((0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(this.props.selectedInstrument.PriceIncrement));
        var xAxisStepI = (this.chartWidth - 35) / (depthChartXAxisStepCnt - 1) * _i2;
        this.ctx2.font = depthChartTextFont;
        this.ctx2.fillStyle = depthChartXAxisStepColor;
        this.ctx2.fillText(xAxisText, xAxisStepI, this.chartHeight - 10);
      }
      for (var _i3 = 0; _i3 < buyLevels; _i3++) {
        var lvl = buyBook[_i3];
        depthShown += lvl.Quantity;
        var x = this.chartWidth / 2 - (center - lvl.Price) * multX;
        var y = this.chartHeight - parseInt(depthShown * multY, 10) - depthChartBottomPadding;
        if (this.mouseHoverBuy) {
          if (this.closestMousePositionInfo.xdiff > Math.abs(lastX - mousePos.x)) {
            this.closestMousePositionInfo.price = lvl.Price;
            this.closestMousePositionInfo.xdiff = Math.abs(lastX - mousePos.x);
            this.closestMousePositionInfo.volume = depthShown;
            this.closestMousePositionInfo.x = lastX;
            this.closestMousePositionInfo.y = y;
          }
        }
        if (lastTextEntryX - x > depthChartXAxisTextPadding && x - 40 > 0) {
          lastTextEntryX = x;
        }
        if (x <= this.chartWidth && y <= this.chartHeight && x >= 0) {
          this.ctx2.beginPath();
          this.ctx2.moveTo(lastX, y);
          this.ctx2.save();
          this.ctx2.lineWidth = 1;
          this.ctx2.lineTo(x, y);
          this.ctx2.strokeStyle = lastTradeUpColor;
          this.ctx2.stroke();
          this.ctx2.beginPath();
          this.ctx2.moveTo(lastX, lastY);
          this.ctx2.lineTo(lastX, y);
          this.ctx2.stroke();
          this.ctx2.restore();
          this.ctx2.fillStyle = lastTradeUpColorTransparent;
          this.ctx2.fillRect(lastX, y, x - lastX, this.chartHeight - depthChartBottomPadding - y);
          if (lastTextEntryY - y >= depthChartYAxisTextPadding && y - 10 > 0) {
            lastTextEntryY = y;
            this.ctx2.save();
            this.ctx2.beginPath();
            this.ctx2.moveTo(x, y);
            this.ctx2.lineW = 1;
            this.ctx2.lineTo(0, y);
            this.ctx2.strokeStyle = lastTradeUpColor;
            this.ctx2.setLineDash([2, 3]);
            this.ctx2.stroke();
            this.ctx2.restore();
          }
          if (x - lastTextEntry >= depthChartXAxisTextPadding) {
            this.ctx2.save();
            this.ctx2.beginPath();
            this.ctx2.moveTo(x, this.chartHeight - depthChartBottomPadding);
            this.ctx2.lineW = 1;
            this.ctx2.lineTo(x, this.chartHeight - 10);
            this.ctx2.strokeStyle = lastTradeUpColor;
            this.ctx2.stroke();
            this.ctx2.restore();
            lastTextEntry = x;
          }
          lastXDrawn = x;
          lastYDrawn = y;
        }
        lastX = x;
        lastY = y;
      }
      this.ctx2.fillStyle = lastTradeUpColorTransparent;
      this.ctx2.fillRect(0, lastYDrawn, lastXDrawn, this.chartHeight - depthChartBottomPadding - lastYDrawn);
      this.ctx2.beginPath();
      this.ctx2.moveTo(lastXDrawn, lastYDrawn);
      this.ctx2.save();
      this.ctx2.lineWidth = 1;
      this.ctx2.lineTo(0, lastYDrawn);
      this.ctx2.strokeStyle = lastTradeUpColor;
      this.ctx2.stroke();
      this.ctx2.restore();
      lastY = this.chartHeight - depthChartBottomPadding;
      lastX = this.chartWidth / 2;
      lastTextEntry = lastX;
      lastTextEntryY = lastY;
      lastX = this.chartWidth / 2 + (parseFloat(sortedSellBook[sortedSellBook.length - 1]) - center) * multX;
      lastTextEntryX = 0;
      var shownum = sortedSellBook.length - sellLevels - 1;
      if (shownum < 0) shownum = 0;
      var depthShownA = 0;
      for (var _i4 = sortedSellBook.length - 1; _i4 >= shownum; _i4--) {
        var _lvl = sellBook[_i4];
        depthShownA += _lvl.Quantity;
        var _x = this.chartWidth / 2 + (_lvl.Price - center) * multX;
        var _y = this.chartHeight - parseInt(depthShownA * multY, 10) - depthChartBottomPadding;
        if (this.mouseHoverSell) {
          if (this.closestMousePositionInfo.xdiff > Math.abs(lastX - mousePos.x)) {
            this.closestMousePositionInfo.xdiff = Math.abs(lastX - mousePos.x);
            this.closestMousePositionInfo.price = _lvl.Price;
            this.closestMousePositionInfo.volume = depthShownA;
            this.closestMousePositionInfo.x = lastX;
            this.closestMousePositionInfo.y = _y;
          }
        }
        if (_x - lastTextEntryX > depthChartXAxisTextPadding && _x + 40 < this.chartWidth) {
          lastTextEntryX = _x;
        }
        if (_x <= this.chartWidth && _y <= this.chartHeight && _x >= 0) {
          this.ctx2.save();
          this.ctx2.beginPath();
          this.ctx2.moveTo(lastX, _y);
          this.ctx2.lineWidth = 1;
          this.ctx2.lineTo(_x, _y);
          this.ctx2.strokeStyle = lastTradeDownColor;
          this.ctx2.stroke();
          this.ctx2.beginPath();
          this.ctx2.moveTo(lastX, lastY);
          this.ctx2.lineTo(lastX, _y);
          this.ctx2.stroke();
          this.ctx2.restore();
          this.ctx2.fillStyle = lastTradeDownColorTransparent;
          this.ctx2.fillRect(lastX, _y, _x - lastX, this.chartHeight - depthChartBottomPadding - _y);
          if (lastTextEntryY - _y >= depthChartYAxisTextPadding && _y - 10 > 0) {
            lastTextEntryY = _y;
            this.ctx2.save();
            this.ctx2.beginPath();
            this.ctx2.moveTo(this.chartWidth, _y);
            this.ctx2.lineW = 1;
            this.ctx2.lineTo(_x, _y);
            this.ctx2.strokeStyle = lastTradeDownColor;
            this.ctx2.setLineDash([2, 3]);
            this.ctx2.stroke();
            this.ctx2.restore();
          }
          if (lastTextEntry - _x >= depthChartXAxisTextPadding) {
            this.ctx2.font = depthChartTextFont;
            this.ctx2.fillStyle = depthChartTextColor;
            this.ctx2.fillText(_lvl.Price.toFixed((0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(this.props.selectedInstrument.PriceIncrement)), _x, this.chartHeight);
            this.ctx2.save();
            this.ctx2.beginPath();
            this.ctx2.moveTo(_x, this.chartHeight - depthChartBottomPadding);
            this.ctx2.lineW = 1;
            this.ctx2.lineTo(_x, this.chartHeight - 10);
            this.ctx2.strokeStyle = lastTradeDownColor;
            this.ctx2.stroke();
            this.ctx2.restore();
            lastTextEntry = _x;
          }
          lastXDrawn = _x;
          lastYDrawn = _y;
        }
        lastX = _x;
        lastY = _y;
      }
      this.ctx2.fillStyle = lastTradeDownColorTransparent;
      this.ctx2.fillRect(lastXDrawn, lastYDrawn, this.chartWidth, this.chartHeight - depthChartBottomPadding - lastYDrawn);
      this.ctx2.beginPath();
      this.ctx2.moveTo(lastXDrawn, lastYDrawn);
      this.ctx2.save();
      this.ctx2.lineWidth = 1;
      this.ctx2.lineTo(this.chartWidth, lastYDrawn);
      this.ctx2.strokeStyle = lastTradeDownColor;
      this.ctx2.stroke();
      this.ctx2.restore();
      this.renderTooltip(depthChartTextFont, depthChartTextColor, lastTradeUpColorTransparent, lastTradeDownColorTransparent);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var t = this.props.t;
      var _this$props2 = this.props,
        DepthChart = _this$props2.DepthChart,
        smallScreen = _this$props2.smallScreen,
        fetching = _this$props2.fetching;
      var chartContainerHeight = DepthChart.depthChartHeight ? DepthChart.depthChartHeight + 50 : 350;
      if (smallScreen) {
        chartContainerHeight = '100%';
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          minHeight: chartContainerHeight,
          height: chartContainerHeight
        },
        className: "".concat(tradeComponentClasses(), " ").concat(depthChartComponentClasses())
      }, fetching && /*#__PURE__*/_react["default"].createElement(_Spinner["default"], null), /*#__PURE__*/_react["default"].createElement("div", {
        id: "depthChartHolder",
        className: "".concat(depthChartComponentClasses(''))
      }, /*#__PURE__*/_react["default"].createElement("canvas", {
        id: "depthchart",
        style: {
          position: 'absolute',
          zIndex: 2,
          width: '100%',
          height: chartContainerHeight
        }
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(depthChartComponentClasses('buttons'))
      }, /*#__PURE__*/_react["default"].createElement("button", {
        className: "".concat(depthChartComponentClasses('button--zoom')),
        onClick: function onClick() {
          return _this2.zoomDepthChartMinus();
        }
      }, "-"), /*#__PURE__*/_react["default"].createElement("span", {
        id: "midMarketPrice"
      }), /*#__PURE__*/_react["default"].createElement("button", {
        className: "".concat(depthChartComponentClasses('button--zoom')),
        onClick: function onClick() {
          return _this2.zoomDepthChartPlus();
        }
      }, "+")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(depthChartComponentClasses('zoom-label'))
      }, t("Zoom: {{zoom}}", {
        zoom: (MAX_ZOOM_VALUE - this.state.depthchartzoom).toFixed(2)
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(depthChartComponentClasses('label'))
      }, t('Mid Market Price'))));
    }
  }]);
}(_react["default"].Component);
DepthChartComponent.defaultProps = {
  smallScreen: false
};
DepthChartComponent.propTypes = {
  store: _propTypes["default"].object.isRequired,
  level2: _propTypes["default"].object.isRequired,
  getCssVar: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = (0, _redux.compose)(_resize["default"], _withCssVars.withCssVars, (0, _reactI18next.withTranslation)('core'))(DepthChartComponent);